/* eslint-disable react/no-danger */
import * as React from 'react';

import type {
  BaseCoursesV1,
  BaseDegreesV1,
  BaseOnDemandSpecializationsV1,
} from 'bundles/collections/utils/catalogCollectionPageUtils';
import { clearEmptyFields } from 'bundles/seo/utils/utils';

type Props = {
  collectionItems: Array<BaseCoursesV1 | BaseDegreesV1 | BaseOnDemandSpecializationsV1 | null>;
  productPrimaryLanguage: string;
};

class CollectionPageSchemaMarkup extends React.Component<Props, {}> {
  getProductTypePath = (item: $TSFixMe) => {
    const { productVariant } = item;

    const isS12n = item.__typename === 'OnDemandSpecializationsV1';
    const isDegree = item.__typename === 'DegreesV1';
    const isMasterTrack = productVariant === 'MasterTrack';

    if (isMasterTrack) {
      return '/mastertrack';
    } else if (isDegree) {
      return '/degrees';
    } else if (isS12n) {
      return '/specializations';
    } else {
      return '/learn';
    }
  };

  createCanonicalCollectionLink(slug: $TSFixMe, productPath: $TSFixMe) {
    const { productPrimaryLanguage } = this.props;
    const subDomain = productPrimaryLanguage === 'en' ? 'www' : productPrimaryLanguage;

    return `https://${subDomain}.coursera.org${productPath}/${slug}`;
  }

  render() {
    const { collectionItems } = this.props;

    if (!collectionItems) {
      return null;
    }

    const markupJson = {
      '@context': 'http://schema.org',
      '@type': 'ItemList',
      itemListElement: collectionItems.map((item, i) => {
        if (!item) return null;
        const productPath = this.getProductTypePath(item);
        return {
          '@type': 'ListItem',
          position: i + 1,
          url: this.createCanonicalCollectionLink(item.slug, productPath),
        };
      }),
    };

    const createMarkup = () => ({
      __html: `
        <script type="application/ld+json">
          ${JSON.stringify(clearEmptyFields(markupJson))}
        </script>
      `,
    });

    return (
      <div className="rc-CollectionPageSchemaMarkup">
        <div dangerouslySetInnerHTML={createMarkup()} />
      </div>
    );
  }
}

export default CollectionPageSchemaMarkup;
